'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../');

var _SubscriptionsList = require('./SubscriptionsList.scss');var styles = _interopRequireWildcard(_SubscriptionsList);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
var formatData = function formatData() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var isAgent = arguments[1];if (isAgent) {
    return data;
  }var _reduce =

  (data || []).reduce(function (acc, item) {
    if (item.name.includes('notify-')) {
      acc.group.push(item);
    } else {
      acc.single.push(item);
    }

    return acc;
  }, { group: [], single: [] }),group = _reduce.group,single = _reduce.single;

  var groupedTopic = group.reduce(function (acc, item) {
    acc.ids = acc.ids ? [].concat(acc.ids, [item.id]) : [item.id];
    return Object.assign({},
    acc,
    item, {
      name: 'notifications-about-active-ads' });

  }, {});

  return [].concat(single, [groupedTopic]);
};var

SubscriptionsList = function (_Component) {_inherits(SubscriptionsList, _Component);function SubscriptionsList() {var _temp, _this, _ret;_classCallCheck(this, SubscriptionsList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    renderList = function () {
      var data = formatData(_this.props.dataList, _this.props.isAgent);

      return !!data && data.map(function (item, idx) {var
        id = item.id,ids = item.ids,name = item.name,is_subscribed = item.is_subscribed;

        return (
          _react2.default.createElement(_.SubscriptionCell, {
            key: id,
            ids: ids || [id],
            translate: _this.props.translate,
            name: name,
            onChange: _this.props.updateSubscription,
            status: is_subscribed,
            isMobile: _this.props.isMobile }));


      });
    }, _temp), _possibleConstructorReturn(_this, _ret);}SubscriptionsList.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.subscriptionList },
        this.renderList()));


  };return SubscriptionsList;}(_react.Component);exports.default = SubscriptionsList;


SubscriptionsList.propTypes = {
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  dataList: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  updateSubscription: _propTypes2.default.func,
  isAgent: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscriptionsList/SubscriptionsList.js
// module id = 2929
// module chunks = 0